import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
import Sticker from "./sticker"
//等待中
export default class StickerReset extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.path = this.el.path;

        this.collectSticker = [];

        mouseEvent.add_mouse_event(this);
    }

    init() {
        this.target.gotoAndStop(0);
        this.collectSticker = this.itemControl.getItemsByClassName("sticker", this);
    }

    trigger() {
        this.collectSticker.forEach(sticker => {

            sticker.target.gotoAndStop(0);
            sticker.whiteTriangle.visible = true;
            //初始觸碰開啟
            sticker.target.mouseEnabled = true;
        });
    }
}